<template>
  <div>
    <!-- <div style="margin-top: 10px; display: flex">
      <div style="width: calc(25% - 10px);margin-left: 10px;overflow-x: hidden;position: relative;">
        <img :src="action + data.img" style="
            width: 185%;
            height: 340px;
            max-width: none;
            position: absolute;
            right: 0px;
          " />
      </div>
      <div style="height: 340px;width: calc(50% - 20px);margin: 0px 10px;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;
        " :style="{ backgroundImage: 'url(' + action + data.img + ')' }">
        <img :src="action + app.img" style="width: 400px;height: 150px;opacity: 0.8;">
      </div>
      <div style="width: calc(25% - 10px); margin-right: 10px; overflow-x: hidden">
        <img :src="action + data.img" style="width: 185%; height: 340px; max-width: none" />
      </div>
    </div> -->
    <div style="margin-top: 30px">
      <div class="mendiv">
        <div @click="setMindex(i)" style="" v-for="(x, i) in menus" :class="[{ mtitle: i == mindex }, { mlist: i != mindex }]">
          {{ x.name }}
        </div>
      </div>
    </div>
    <div style="width: 100%;overflow: hidden;position: relative;">
      <div ref="wipper" style="margin-top: 10px; display: flex;width:calc(350% + 10px);"
        :style="'transform:translateX(' + left + '%);transition:' + (transition ? 'all .5s' : 'none')">
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[2].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[0].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[1].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[2].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[0].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[1].img"></div>
        <div style="width: 25%;padding:0px 5px;"><img style="width: 100%;" :src="action + data[2].img"></div>
      </div>
      <div @mouseenter="nmouseenter" @mouseleave="nmouseleave"
        style="position: absolute;width: 100%;height: 100%;z-index: 99999;display: flex;justify-content: space-between;align-items: center;top: 0px;">
        <div>
          <!-- :style="index == 0 ? 'cursor: no-drop;' : ''" -->
          <div v-if="buttonshow" @click="nextClickc"
            style="width: 40px;height: 40px;background-color: rgba(246, 246, 246, 0.9);border-radius: 50%;color: #333;text-align: center;line-height:40px;font-size: 32px;font-weight: normal;margin-left: 20px;cursor: pointer;">
            < </div>
          </div>
          <div style="height: 100%;width: 50%;cursor: pointer;" @click="to()"></div>
          <div>
            <div @click="nextClick" v-if="buttonshow"
              style="width: 40px;height: 40px;background-color: rgba(246, 246, 246, 0.9);border-radius: 50%;color: #333;text-align: center;line-height:40px;font-size: 32px;font-weight: normal;margin-right: 20px;cursor: pointer;">
              ></div>
          </div>
        </div>
      </div>
      <div style="
        height: 370px;
        width: 100%;
        position: relative;
        padding-top: 30px;
        overflow: hidden;
      ">
        <img src="../../assets/images/Background4.png" style="
          position: absolute;
          width: 100%;
          height: 420px;
          top: 0px;
          left: 0px;
          opacity: 0.5;
        " />
        <!-- opacity: 0.8; -->
        <div style="
          position: relative;
          padding-bottom: 35px;
          width: calc(50% - 30px);
          margin: 0px auto;
          border-top: 3px solid #1e66d1;
          background: rgb(255 255 255 / 60%);
        ">
          <div style="
            font-size: 24px;
            font-weight: bold;
            margin-top: 35px;
            text-align: center;
          ">
            {{ data[indexb].title }}
          </div>
          <div style="
            font-size: 14px;
            margin-top: 35px;
            padding: 0px 55px;
            line-height: 25px;
          ">
            {{ data[indexb].text }}
          </div>
          <div @click="to()" style="
            margin: 0px auto;
            cursor: pointer;
            margin-top: 40px;
            width: 115px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border: 1px solid #1e66d1;
            color: #1e66d1;
          ">
            查看详情>
          </div>
        </div>
      </div>
      <div style="
        font-size: 30px;
        font-weight: normal;
        text-align: center;
        padding-top: 15px;
        background: #f8f8fa;
        padding-bottom: 38px;
      ">
        更多合作案例
      </div>
      <div style="
        background: #f5f7fa;
        box-shadow: inset rgba(176, 176, 176, 0.5) 0px 2px 16px 0px;
      ">
        <div class="hezuoanlie"
          style="display: flex;flex-wrap: wrap;width: 1200px;justify-content: center;margin: 0px auto;justify-content:space-between;padding:35px 0px;">
          <div v-show="x.img" style="margin: 10px;padding: 0px 0px;background: #fff;width: 23%;" v-for="(x, i) in apps"
            :key="i">
            <img style="width: 100%;" :src="action + x.img">
          </div>
        </div>
      </div>
    </div>
</template>
<script>
// <!-- //轮播 -->
// <!-- https://cloud.tencent.com/developer/article/2427752 -->
import { getJsonTree } from "@/utils/index";
export default {
  data() {
    return {
      action: window["pathConfig"][process.env.NODE_ENV].ImgURL,
      mindex: 0,
      menus: [],
      apps: [],
      data: [{}, {}, {}],
      indexb: 1,
      index: 1,
      transition: false,
      buttonshow: false,
      left: -21.42857
    };
  },
  created() {
    this.$http("/Plan/GetTypeData", { isall: 3 }).then((x) => {
      if (x.data.length > 0) {
        var data = getJsonTree(x.data.filter(z=>z.name != '央企' && z.name != '国企' && z.pid != '8a0188db-59aa-4d38-8302-38e3ea7613ab' && z.pid != '13c7e93e-cc32-4b77-8eba-c82e10062d24'), "", "pid");
        this.menus = data;
        this.load()
      }
    });
  },
  activated() {
    // this.$http("/Plan/GetTypeData", { isall: 3 }).then((x) => {
    //   if (x.data.length > 0) {
    //     var data = getJsonTree(x.data, "", "pid");
    //     this.menus = data;
    //     this.load()
    //   }
    // });
    var id = this.$route.query.id
    if (id) {
      this.menus.forEach((x, i) => {
        if (x.ID == id) {
          this.setMindex(i);
        }
      })
    }
  },
  mounted() {
  },
  methods: {
    load() {
      var id = this.$route.query.id
      if (id) {
        this.menus.forEach((x, i) => {
          if (x.ID == id) {
            this.setMindex(i);
          }
        })
      } else
        this.setMindex(0);
    },
    to() {
      this.$router.push({ name: "crmcaseinfo", query: { id: this.menus[this.mindex].ID, index: this.indexb } });
    },
    setMindex(i) {
      this.mindex = i;
      this.apps = this.menus[i].children;
      this.getInfo(this.menus[i].ID);
    },
    getInfo(id) {
      clearInterval(this.timer);
      this.transition = false
      this.index = 1
      this.indexb = 1
      this.$http("/CrmCase/GetDetails", { menuid: id }).then((x) => {
        if (x.length > 0) {
          if (this.$route.query.title) {
            var title = this.$route.query.title
            var i = x.findIndex(function (x) { return x.title == title })
            console.log(i,x)
            if (i >= 0) {
              this.index = i
              this.indexb = i
            }
          }
          this.data = x;
          this.left = -this.index * 14.28571 - 7.14285
          this.nmouseleave()
        }
      });
      this.$router.push('/crmcase')
    },
    nextClickc() {
      this.transition = true
      this.index--
      this.left = -this.index * 14.28571 - 7.14285
      if (this.index == 0) {
        var _this = this
        this.index = 3
        this.indexb = 0
        setTimeout(() => {
          _this.transition = false
          _this.left = -this.index * 14.28571 - 7.14285
        }, 500);
      } else {
        if (this.indexb == 0) {
          this.indexb = 2
        }
        else {
          this.indexb--
        }
      }
    },
    nextClickb() {
      if (this.indexb == 2) {
        this.indexb = 0
      } else {
        this.indexb++
      }
    },
    nextClick() {

      //点击时index自增
      this.index++;
      this.nextClickb()
      //给盒子过渡效果，向左移动
      this.transition = true
      this.left = -this.index * 14.28571 - 7.14285
      //判断如果到了最后一张
      if (this.index == 4) {
        // 初始化index=0
        this.index = 1;
        // 设置定时器把最后一张变为第一张
        var _this = this
        setTimeout(() => {
          _this.transition = false
          _this.left = -21.42857
        }, 500);
      }
    },
    nmouseenter() {
      this.buttonshow = true
      clearInterval(this.timer);
    },
    nmouseleave() {
      this.buttonshow = false
      if (this.timer != null) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.nextClick, 3000);
    }
  },
};
</script>
<style scoped>
.mendiv {
  display: flex;
  justify-content: center;
}

.mtitle {
  color: #fff;
  background: #1e66d1;
  font-size: 16px;
  /* padding: 0px 10px!important; */
  /* padding: 0px 35px !important; */
}

.mendiv div {
  /* padding: 0px 35px; */
  /* padding: 0px 10px; */
  min-width: 100px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
}

.mlist:hover {
  color: #1e66d1;
  /* font-size: 16px; */
  background: #f2f2f2;
}
</style>